// ─── Jahres-Helfer für den Zeit-Schieberegler ───────────────────────────────

import type { TreeNode } from '@/api/tree.api';

/** Erste vierstellige Jahreszahl aus einem Freitext-Datum („12. März 1880", „ca. 1850"). */
export function extractYear(text: string | null | undefined): number | null {
  if (!text) return null;
  const m = text.match(/\d{4}/);
  return m ? parseInt(m[0], 10) : null;
}

export type TemporalState = 'unborn' | 'alive' | 'dead' | 'unknown';

/** Zustand einer Person im gewählten Jahr. „unknown" = keine Datumsdaten → bleibt sichtbar. */
export function temporalStateAt(
  birthText: string | null | undefined,
  deathText: string | null | undefined,
  year: number,
): TemporalState {
  const birth = extractYear(birthText);
  const death = extractYear(deathText);
  if (birth !== null && year < birth) return 'unborn';
  if (death !== null && year > death) return 'dead';
  if (birth !== null || death !== null) return 'alive';
  return 'unknown';
}

/** Min-/Max-Jahr über alle Geburts-/Sterbedaten (für den Slider-Bereich). */
export function yearRange(nodes: TreeNode[]): { min: number; max: number } | null {
  let min = Infinity;
  let max = -Infinity;
  for (const n of nodes) {
    for (const y of [extractYear(n.birthDateText), extractYear(n.deathDateText)]) {
      if (y === null) continue;
      if (y < min) min = y;
      if (y > max) max = y;
    }
  }
  if (min === Infinity) return null;
  return { min, max };
}
